/**
 * Qué estados de una conversación puede VER una persona, y cuáles son asunto interno del sistema.
 *
 * 🚨 POR QUÉ ESTO ES UNA LISTA BLANCA Y NO UN `!== 'archived'`. La bandeja se filtraba diciendo
 * «mostrá todo lo que no esté archivado». Con esa forma, cualquier estado que el sistema invente
 * aparece en la pantalla del usuario sin que nadie lo haya decidido: el default es mostrar.
 *
 * Pasó de verdad. Al unir los chats partidos por el LID, la conversación vacía que queda se marcaba
 * `archived` —el estado que usa una PERSONA para decir «ya terminé con esto»— y se colaba en su
 * carpeta como si fuera un chat más: «¿por qué el WhatsApp de Andrea y Mariangela están duplicados y
 * aparecen en archivados?». No estaban duplicados: eran los cascarones de la fusión, con 0 mensajes.
 *
 * 🪤 Y ARREGLAR SOLO EL ESTADO HABRÍA EMPEORADO LA COSA. Cambiarlo a `merged` sin invertir el filtro
 * movía el cascarón de Archivados a la BANDEJA PRINCIPAL — el mismo bug, más a la vista. Por eso las
 * dos mitades van juntas: el sistema nombra bien lo suyo, y la UI muestra solo lo que decidió mostrar.
 *
 * La misma regla vive en SQL dentro de `fn_wa_inbox_counts`: si acá se agrega un estado y allá no,
 * el número del sidebar deja de coincidir con la lista y nadie sabe por qué.
 */

/** Estados que existen para el usuario. Lo que no está acá, no se muestra en ninguna vista. */
export const ESTADOS_VISIBLES = ['pending', 'open', 'snoozed', 'resolved', 'archived'] as const;

/** Estados internos: resultados del sistema, no decisiones de una persona. */
export const ESTADOS_INTERNOS = ['merged'] as const;

/** ¿Esta conversación existe para el usuario? */
export function esVisibleParaElUsuario(status: string | null | undefined): boolean {
  return (ESTADOS_VISIBLES as readonly string[]).includes(status ?? '');
}

/** ¿Va en la bandeja principal? (visible y no archivada — archivados tienen su propio cajón.) */
export function vaEnLaBandeja(status: string | null | undefined): boolean {
  return esVisibleParaElUsuario(status) && status !== 'archived';
}
